/* global Modal, Shopify */

/**
 * "Experience our new site" popup.
 *
 * For eligible visitors (per the geo API) this opens once per browser session
 * and offers to redirect them to the new storefront. It reuses the theme's
 * <modal-dialog> behaviour (focus trap, Esc-to-close, scale/fade transitions)
 * by extending the global Modal class.
 */
(() => {
  const API_URL = 'https://geo.boutiquerugs.com/location';
  const REDIRECT_URL = 'https://next.boutiquerugs.com';
  const SESSION_KEY = 'new-site-popup-seen';

  if (customElements.get('new-site-popup')) return;

  customElements.whenDefined('modal-dialog').then(() => {
    class NewSitePopup extends Modal {
      constructor() {
        super();

        this.continueButton = this.querySelector('.js-new-site-continue');
        if (this.continueButton) {
          this.continueButton.addEventListener('click', () => {
            this.markSeen();

            let redirected = false;
            const redirect = () => {
              if (redirected) return;
              redirected = true;
              window.location.href = REDIRECT_URL;
            };

            // Fire the GTM event, then redirect once tags finish (or after the
            // timeout). eventCallback only runs when GTM is present, so a
            // matching fallback timer guarantees the redirect either way.
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'new_site_continue',
              eventCallback: redirect,
              eventTimeout: 200,
            });
            setTimeout(redirect, 200);
          });
        }

        // Never auto-open inside the theme editor.
        if (window.Shopify && Shopify.designMode) return;

        if (this.alreadySeen()) return;
        this.checkEligibility();
      }

      alreadySeen() {
        try {
          return sessionStorage.getItem(SESSION_KEY) === '1';
        } catch (e) {
          return false;
        }
      }

      markSeen() {
        try {
          sessionStorage.setItem(SESSION_KEY, '1');
        } catch (e) {
          /* sessionStorage unavailable — ignore */
        }
      }

      async checkEligibility() {
        try {
          const response = await fetch(API_URL, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;

          const data = await response.json();
          if (data && data.eligible === true) this.open();
        } catch (e) {
          /* Network/CORS error — fail silently, no popup. */
        }
      }

      /**
       * Opens the modal. Marks the session as seen the moment it's shown so it
       * won't reappear on the next page view within the same visit.
       * @param {Element} [opener] - Element that triggered the modal.
       */
      open(opener) {
        this.markSeen();
        super.open(opener);
      }
    }

    customElements.define('new-site-popup', NewSitePopup);
  });
})();
